/**
 * Шаблон конфига
 * Автоматически дописывается данными из конфига при сборке проекта
 * Локально можно менять, коммитить следует только как шаблон внутри utils/build-configs-params-transfer
 * В конец файла будет дописан следующий код
 * export const BUILD_CONFIG: BuildConfig = {};
 * где внутри будет указан конфиг
 */

export type Runtime = 'web' | 'ios' | 'android';

export type Platform = 'vk' | 'ok' | 'fbInstant' | 'ya' | 'cg' | 'none';

export type Environment = 'personal' | 'develop' | 'stable' | 'master' | 'production';

export type BuildType = 'preview' | 'release';

export interface BuildConfig {
	runtime: Runtime;
	platform: Platform;
	env: Environment;
	type: BuildType;
	readonly buildNumber: number;
	readonly buildDate: string;
	readonly cocosCreatorVersion: string;
	readonly gitCommit: string;
	readonly gitBranch: string;
	// TODO add vk & ok app ids
	readonly apps: {
		[platform in Exclude<Platform, 'none' | 'vk' | 'ok'>]: {
			[env in Environment]: { appId: string; [key: string]: unknown };
		};
	};
}

export function detectEnv(hostname: string, platform: Platform): Environment {
	// отдельная логика определения env для ФБ, так как ФБ билды хостятся не на наших хостах
	if (platform === 'fbInstant') {
		const { develop, stable, master, production } = BUILD_CONFIG.apps[platform];

		if (hostname.endsWith(`${develop.appId}.apps.fbsbx.com`)) {
			return 'develop';
		} else if (hostname.endsWith(`${stable.appId}.apps.fbsbx.com`)) {
			return 'stable';
		} else if (hostname.endsWith(`${master.appId}.apps.fbsbx.com`)) {
			return 'master';
		} else if (hostname.endsWith(`${production.appId}.apps.fbsbx.com`)) {
			return 'production';
		} else {
			return 'personal';
		}
	}

	if (hostname.startsWith('client-develop')) {
		return 'develop';
	} else if (hostname.startsWith('client-stable')) {
		return 'stable';
	} else if (hostname.startsWith('client-master')) {
		return 'master';
	} else if (hostname.startsWith('goblins-static')) {
		return 'production';
	} else {
		return 'personal';
	}
}

export function envNum(env: Environment) {
	switch (env) {
		case 'personal':
			return 0;
		case 'develop':
			return 1;
		case 'stable':
			return 2;
		case 'master':
			return 3;
		case 'production':
			return 4;

		default:
			const num: never = env;
			throw new Error(`Unknown environment! [value: ${env}]`);
	}
}

export function platformTag(platform: Platform) {
	switch (platform) {
		case 'vk':
		case 'ok':
		case 'ya':
		case 'cg':
		case 'none':
			return platform;
		case 'fbInstant':
			return 'fb';

		default:
			const tag: never = platform;
			throw new Error(`Unknown environment! [value: ${platform}]`);
	}
}

export const BUILD_CONFIG: BuildConfig = {
	"runtime": "web",
	"platform": "none",
	"env": "develop",
	"type": "release",
	"buildNumber": "543",
	"buildDate": "2025-11-11 13:24",
	"cocosCreatorVersion": "3.8.4",
	"gitCommit": "c24a512b53a05a0c4b0260c72993cfecb4011d26",
	"gitBranch": "master",
	"apps": {
		"vk": {
			"personal": {
				"appId": "51753504"
			},
			"develop": {
				"appId": "51676043"
			},
			"stable": {
				"appId": "51676049"
			},
			"master": {
				"appId": "51676055"
			},
			"production": {
				"appId": "51676057"
			}
		},
		"ok": {
			"personal": {
				"appId": "512002048307"
			},
			"develop": {
				"appId": "512002075061"
			},
			"stable": {
				"appId": "512002025370"
			},
			"master": {
				"appId": "512002078099"
			},
			"production": {
				"appId": "512001929797"
			}
		},
		"ya": {
			"personal": {
				"appId": "303797"
			},
			"develop": {
				"appId": "311149"
			},
			"stable": {
				"appId": "311163"
			},
			"master": {
				"appId": "311165"
			},
			"production": {
				"appId": "311166"
			}
		},
		"cg": {
			"personal": {
				"appId": "061f6e2b-6e4f-4543-aea4-0fffbb6fed54",
				"xsollaProjectId": "270453"
			},
			"develop": {
				"appId": "f8819d3f-3db3-4fae-b64d-170635380022",
				"xsollaProjectId": "270453"
			},
			"stable": {
				"appId": "6e019297-b57e-4003-8191-5449140693af",
				"xsollaProjectId": "270505"
			},
			"master": {
				"appId": "8163673d-4949-4ebd-8cf1-8b9e6a09eced",
				"xsollaProjectId": "270506"
			},
			"production": {
				"appId": "5253d818-cf7d-4b86-931b-997cc18db8d4",
				"xsollaProjectId": "270454"
			}
		},
		"fbInstant": {
			"personal": {
				"appId": "1150237969663659"
			},
			"develop": {
				"appId": "1150237969663659"
			},
			"stable": {
				"appId": "918274610037700"
			},
			"master": {
				"appId": "971032394638295"
			},
			"production": {
				"appId": "1062414028379441"
			}
		}
	}
};